import React, { useMemo } from 'react';

import ModalSetFS from '@src/components/Modal/sets/modalSetFS';
import HeaderShowContact from '@src/components/HeaderShowContact';
import MediaBigManageCLoader from '@src/components/MediaBigManage/connector/MediaBigManageCLoader';
import PopoverShareCDefault from '@src/components/PopoverShare/connectors/default';

import MediaBigFS from '..';

const MediaBigFSCVenue = (props) => {
	const {
		media,
		neighbours,
		details,
		placeTitle,
		onClickNext,
		onClickPrev,
		onClose,
		onClickContacts,
		isOpened,
		...rest
	} = props;

	const mediaProps = useMemo(() => {
		const img = { ...media, leadHeight: 1000, forceVisibility: true };
		return {
			isWatchLoading: true,
			media: {
				img,
			},
			neighbours,
			onClickPrev,
			onClickNext,
		};
	}, [onClickNext, onClickPrev, media, neighbours]);

	const headerProps = useMemo(() => {
		return {
			onClickBtn: () => {
				onClickContacts();
			},
		};
	}, [onClickContacts]);

	const href = global.location?.href || '/';

	const popoverProps = useMemo(() => {
		return { href };
	}, [href]);

	return (
		<ModalSetFS isOpen={isOpened} onClose={onClose}>
			<MediaBigFS
				label={`${details.title}${
					placeTitle ? ` · ${placeTitle}` : ''
				}`}
				MediaRP={MediaBigManageCLoader}
				HeaderRP={HeaderShowContact}
				mediaProps={mediaProps}
				headerProps={headerProps}
				popoverProps={popoverProps}
				Popover={PopoverShareCDefault}
				{...rest}
			/>
		</ModalSetFS>
	);
};

MediaBigFSCVenue.propTypes = {
	...MediaBigFS.propTypes,
};

export default MediaBigFSCVenue;
